// src/components/ProfileMenuItem.tsx
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

export type TMenuItemProps = {
  label: string;
  icon: string;
  href?: string;
  action?: () => void;
  showChevron?: boolean;
  onClose?: () => void;
};

export default function CWProfileMenuItem({
  label,
  icon,
  href,
  action,
  showChevron,
  onClose,
}: TMenuItemProps) {
  const content = (
    <>
      <span className="text-[22px]">
        <Image src={icon} alt={label} width={22} height={22} />
      </span>
      <span className="flex-1 text-left">{label}</span>
      {showChevron && (
        <span className="text-[22px] opacity-60">
          <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path
              d="M9 6l6 6-6 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      )}
    </>
  );

  if (href) {
    return (
      <Link href={href} className="block" onClick={onClose}>
        <div className="flex w-full cursor-pointer items-center gap-3 px-6 py-4 text-[20px] font-medium text-white transition hover:cursor-pointer hover:bg-[#333]">
          {content}
        </div>
      </Link>
    );
  }

  return (
    <button
      className="flex w-full items-center gap-3 px-6 py-4 text-[20px] font-medium text-white transition hover:cursor-pointer hover:bg-[#333]"
      onClick={action}
    >
      {content}
    </button>
  );
}
